import { render, staticRenderFns } from "./PresenceAvatarStack.vue?vue&type=template&id=7b93a57e&scoped=true"
import script from "./PresenceAvatarStack.vue?vue&type=script&lang=js"
export * from "./PresenceAvatarStack.vue?vue&type=script&lang=js"
import style0 from "./PresenceAvatarStack.vue?vue&type=style&index=0&id=7b93a57e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b93a57e",
  null
  
)

export default component.exports